import { useEffect, useState } from 'react'

import { Loader } from '@googlemaps/js-api-loader'

type UseMapsApiLoaderDto = {
  apiKey: string
}

type UseMapsApiLoaderResponse = {
  isLoaded: boolean
}

export function useJsApiLoader({
  apiKey,
}: UseMapsApiLoaderDto): UseMapsApiLoaderResponse {
  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  useEffect(() => {
    const loader = new Loader({
      apiKey,
      version: 'weekly',
      libraries: ['places'],
    })

    loader.load().then(() => {
      setIsLoaded(true)
    })
  }, [apiKey])

  return { isLoaded }
}
